import { useMediaQuery } from "react-responsive";
import { MEDIA_QUERIES } from "../utils/breakpoints";

export const useBreakpoints = () => {
  return {
    isMobile: useMediaQuery({ query: MEDIA_QUERIES.MOBILE }),
    isTablet: useMediaQuery({ query: MEDIA_QUERIES.TABLET }),
    isDesktop: useMediaQuery({ query: MEDIA_QUERIES.DESKTOP }),
    isLargeDesktop: useMediaQuery({ query: MEDIA_QUERIES.LARGE_DESKTOP }),
  };
};
